import React, { Component } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";

import LoginPage        from "./components/LoginPage";
import SignupPage       from "./components/SignupPage";
import LandingPage      from "./pages/LandingPage.jsx";
import NotApprovedPage  from "./pages/NotApprovedPage";

import SuperadminEntry  from "./routing/SuperadminEntry.jsx";
import AdminEntry       from "./routing/AdminEntry.jsx";
import AntrenorEntry    from "./routing/AntrenorEntry.jsx";      
import EchipaEntry      from "./routing/EchipaEntry.jsx";   

import ThemeProvider    from "./components/ThemeProvider";
import MainMenu         from "./components/MainMenu";

import "./css/theme.scss";
import "./index.scss";

import { getSession, getRole } from "./utils/helpers.js";

class App extends Component {
  render() {
    const session         = getSession();
    const role            = getRole(session);
    const isAuthenticated = !!session;

    return (
      <ThemeProvider>
        <Router>
          <MainMenu />

          <Routes>
            {/* Public */}
            <Route path="/"              element={<LandingPage />} />
            <Route path="/signup"        element={<SignupPage />} />
            <Route path="/login"         element={<LoginPage />} />
            <Route path="/not-approved"  element={<NotApprovedPage />} />

            {/* Dashboard – Super-Admin ( / superadmin) */}
            <Route
              path="/superadmin"
              element={
                isAuthenticated && role === "superadmin"
                  ? <SuperadminEntry />
                  : <Navigate to="/login" />
              }
            />

            {/* Dashboard - Admin ( / admin / superadmin) */}
            <Route
              path="/admin"
              element={
                isAuthenticated && ["superadmin", "admin"].includes(role)
                  ? <AdminEntry />
                  : <Navigate to="/login" />
              }
            />

            {/* Dashboard - Antrenor ( / coach / admin / superadmin) */}
            <Route
              path="/antrenor"
              element={
                isAuthenticated &&
                ["superadmin", "admin", "coach"].includes(role)
                  ? <AntrenorEntry />
                  : <Navigate to="/login" />
              }
              />
            
            
            {/* Dashboard – echipa ( viewer / jucator / coach / admin / superadmin)*/}
            {<Route
              path="/echipa"
              element={
                isAuthenticated &&
                ["superadmin", "admin", "coach", "player", "viewer"].includes(role)
                  ? <EchipaEntry />
                  : <Navigate to="/login" />
              }
            /> }
          

          </Routes>
        </Router>
      </ThemeProvider>
    );
  }
}

export default App;
